import { useMutation, useQueryClient } from '@tanstack/react-query';
import { nfseApi } from './api';
import { fiscalKeys } from '@/features/fiscal/hooks';

export function useNfseDownload() {
  return useMutation({
    mutationFn: ({ issuanceId, kind }: { issuanceId: string; kind: 'xml' | 'pdf' }) =>
      nfseApi.signedUrl(issuanceId, kind),
  });
}

export function useCancelNfse(fiscalRecordId: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (reason: string) => nfseApi.cancel(fiscalRecordId!, reason),
    onSuccess: () => {
      if (fiscalRecordId) {
        qc.invalidateQueries({ queryKey: fiscalKeys.detail(fiscalRecordId) });
      }
      qc.invalidateQueries({ queryKey: ['fiscal', 'month'] });
    },
  });
}
